'use client';

import { useAbsolutePath } from '@svs/nova-core/nextjs/cms';
import { TabLink, TabLinks } from '@svs/ui/react/tabs-links';
import Link from 'next/link';
import { useSelectedLayoutSegment } from 'next/navigation';
import { type ReactElement } from 'react';

import { personuppgifterItem, spelreglerItem, villkorItem } from '../lib/constants/resources';
import { getActiveNavPath } from '../utils/getActiveNavPath';

export default function Nav(): ReactElement {
  const selectedSegment = useSelectedLayoutSegment();
  const activePath = getActiveNavPath(selectedSegment);

  const tabs = [
    { ...villkorItem, absoluteHref: useAbsolutePath(villkorItem.href) },
    { ...personuppgifterItem, absoluteHref: useAbsolutePath(personuppgifterItem.href) },
    { ...spelreglerItem, absoluteHref: useAbsolutePath(spelreglerItem.href) },
  ];

  return (
    <TabLinks stretchItems context="surface" ariaLabel="Villkor, personuppgifter och spelregler">
      {tabs.map((tab) => {
        const isActive = activePath === tab.href;
        return (
          <TabLink key={tab.value} asChild isActive={isActive} className="text-tabs-fg">
            <Link href={tab.absoluteHref} prefetch={false} aria-current={isActive ? 'page' : undefined}>
              {tab.label}
            </Link>
          </TabLink>
        );
      })}
    </TabLinks>
  );
}
